export const FAQS = [
  {
    q: "What type of IT training does ZaranTech provide?",
    a: "ZaranTech offers IT training across SAP, SAP AI, Workday, AI productivity tools (Claude, Microsoft Copilot), corporate training, and leadership programs ,  for both individual learners and enterprise teams.",
  },
  {
    q: "Does ZaranTech offer SAP training?",
    a: "Yes. We run SAP training programs across modules, S/4HANA Public Cloud, and bundled paths for both newcomers and experienced consultants.",
  },
  {
    q: "Does ZaranTech offer SAP AI and SAP Joule training?",
    a: "Yes. We have dedicated tracks for SAP AI for MM Consultants, SAP Joule, Joule Deep Dive, and SAP Agentic AI ,  covering both functional and architectural perspectives.",
  },
  {
    q: "Does ZaranTech provide Workday training?",
    a: "Yes. Our Workday programs cover HCM, Integrations (EIB, PECI, Studio), and Reporting.",
  },
  {
    q: "Can companies request customized corporate training?",
    a: "Yes. We design corporate training around your team's roles, projects, and outcomes ,  across SAP, Workday, AI tools, and leadership programs.",
  },
  {
    q: "Does ZaranTech offer live instructor-led training?",
    a: "Yes. Most programs include live instructor-led sessions with real-time interaction, doubt clearing, and structured assignments.",
  },
  {
    q: "Are self-paced courses available?",
    a: "Yes. Many programs are available in a self-paced format with structured recorded content for working professionals.",
  },
  {
    q: "How do I choose the right course?",
    a: "You can talk to a training advisor who'll understand your goals, current role, and target outcomes ,  then map you to the right track or bundle.",
  },
  {
    q: "Can I speak with a training advisor before enrolling?",
    a: "Yes. Request course guidance from any page on the site and our team will reach out to discuss your needs.",
  },
  {
    q: "Does ZaranTech provide AI training for professionals and leaders?",
    a: "Yes. We offer AI for Professionals and AI for Leaders programs, plus tool-specific tracks on Claude, Microsoft Copilot, and agentic AI patterns.",
  },
];
